import { Pages } from './pages';
import { royalSlider } from '../components/royalslider.component';
import { SimilarOffersComponent } from '../components/similar-offers.component';
import { CalendarComponent } from '../components/calendar.component';
import { AccommodationsPresentationComponent } from '../components/accommodations-presentation.component';
import { HotelsSwiperComponent } from '../components/hotels-swiper.component';
import { HotelIntroComponent } from '../components/deal-page/hotel-intro.component';
import { DealMeasurements } from './deal-measurements';
import { FetchHandler } from '../helper/fetchhandler';
import { ToastMessage } from '../helper/toast-message';
import { CampaignAbandonmentComponent } from '../components/deal-page/campaign-abandonment.component';

class DealPage extends Pages {

    constructor(container) {
        super(container);
        this.init();
    }

    init() {
        this.initAccommodationPresentationSwiper();
        this.initCarouselSlideEvent();
        this.initFullscreenMapEvent();
        this.initHotelsSwiper();
        this.royalSliderInit();
        this.initStickyPosition();
        this.initCollapsedText();
        this.initStickyPriceVisible();
        this.initSimilarOffers();
        this.initCalendar();
        new DealMeasurements(this.getContainer());
        this.initPackageModalEvent();
        this.initInfoBoxModalEvent();
        new CampaignAbandonmentComponent();
    }

    /**
     * Accommodation introduction swiper
     */
    initAccommodationPresentationSwiper() {
        new AccommodationsPresentationComponent();
    }

    /**
     * Available hotels swiper
     */
    initHotelsSwiper() {
        new HotelsSwiperComponent();
    }

    /**
     * Init gallery carousel
     */
    initCarouselSlideEvent() {
        $('#dealCarousel').on('slide.bs.carousel', (event) => {
            $('#dealCarousel .js-deal-carousel-count').text(event.to + 1);
        });
    }

    /**
     * Init Google map modal
     */
    initFullscreenMapEvent() {
        this.getContainer().find('.fullscreen-map-toggle').on('click.dealPage', (event) => {
            event.preventDefault();
            $('body').toggleClass('overflow-hidden');
            this.getContainer().find('.fullscreen-map').toggleClass('fullscreen-map--open');
        });
    }

    /**
     * Init the full screen gallery
     */
    royalSliderInit() {
        $('#dealCarousel').find('.carousel-item').on('click.dealPage', () => {
            royalSlider(this.getContainer());
        });

        $('#hotelDescriptionBox').find('.slide-element').on('click.hotelImageSlider', () => {
            royalSlider(this.getContainer());
        });
    }

    /**
     * Init sticky box
     */
    initStickyPosition() {
        const stickyBox = $('#stickyPriceBox');
        stickyBox.css('top', $('.countdown').is(':visible') ? '110px' : '10px');
        $(window).on('scroll', $(window).throttle(() => {
            stickyBox.toggleClass('deal-page__sticky-element--active', $(window).scrollTop() > 800);
        }, 250));
    }

    /**
     * Init collapsable text box
     */
    initCollapsedText() {
        const aboutText = $('#aboutText');
        if (aboutText.length > 0) {
            new HotelIntroComponent(aboutText.height());
        }
    }

    initStickyPriceVisible() {
        $(window).scroll($(window).throttle(() => {
            const stickyPrice = this.getContainer().find('.sticky-price');
            const orderBox = this.getContainer().find('.deal-order-box').first();
            const visibleHeight = orderBox.offset().top + orderBox.outerHeight();
            if (stickyPrice.hasClass('sticky-price--visible') && $(window).scrollTop() < visibleHeight) {
                stickyPrice.removeClass('sticky-price--visible');
            }
            else if ($(window).scrollTop() > visibleHeight) {
                stickyPrice.addClass('sticky-price--visible');
            }
        }, 250));
    }

    /**
     * Initialize the similar offer swiper
     */
    initSimilarOffers() {
        new SimilarOffersComponent();
    }

    /**
     * Initialize the free-room calendar
     */
    initCalendar() {
        new CalendarComponent();
    }

    initInfoBoxModalEvent() {
        const informationLink = this.getContainer().find('#moreInformationLink');

        informationLink.on('click.informationBoxModalEvent', (event) => {
            event.preventDefault();

            const dealId = $(event.currentTarget).data('id');

            if (dealId === null) {
                throw { reason: 'No packageID provided!' };
            }

            FetchHandler
            .create()
            .setMethod('GET')
            .setXMLHttpRequest()
            .setUrl(`/get-dsa-information-modal/${dealId}`)
            .setBody(null)
            .send()
            .then((response) => {
                this.modalHandler(response, false);
            })
            .catch(() => {
                const toastMessage = ToastMessage.getInstance();
                toastMessage.showError('Váratlan hiba történt az adatok betöltése közben! Próbáld újra!');
            });
        });
    }

    initPackageModalEvent() {
        const dealBoxes = this.getContainer().find('.hotels-swiper').find('.deal-box');

        dealBoxes.on('click.dealBoxModalEvent', (event) => {
            const packageId = $(event.currentTarget).data('id');

            if (packageId === null || typeof packageId === 'undefined') {
                throw { reason: 'No packageID provided!' };
            }

            FetchHandler
            .create()
            .setMethod('GET')
            .setXMLHttpRequest()
            .setUrl(`/get-package-modal/${packageId}`)
            .setBody(null)
            .send()
            .then((response) => {
                this.modalHandler(response);
            })
            .catch(() => {
                const toastMessage = ToastMessage.getInstance();
                toastMessage.showError('Váratlan hiba történt az adatok betöltése közben! Próbáld újra!');
            });
        });
    }

    modalHandler(response, needCarousel = true) {
        const modalWrapper = this.getContainer().find('.package-modal-wrapper');
        modalWrapper.html(response.modalHtml);

        const hotelModal = this.getContainer().find('.hotelModal');

        if (hotelModal.length === 0) {
            return;
        }

        const hotelModalInstance = new Modal(hotelModal[0]);

        if (needCarousel === true) {
            this.modalCarouselHandler(hotelModal);
        }

        hotelModalInstance.toggle();
    }

    modalCarouselHandler(hotelModal) {
        const hotelCarousel = hotelModal.find('.hotelCarousel');
        const slideCountElement = hotelModal.find('.js-hotel-carousel-count');

        const hotelImagesCarousel = new Carousel(hotelCarousel[0]);

        const updateSlideCount = () => {
            const activeIndex = hotelImagesCarousel._getItemIndex(hotelCarousel.find('.carousel-item.active')[0]);
            slideCountElement.text(activeIndex + 1);
        };

        updateSlideCount();

        hotelCarousel.on('slid.bs.carousel', updateSlideCount);
    }

}

$(() => {
    const dealPage = $('#deal-page');
    if (dealPage.length > 0) {
        new DealPage(dealPage);
    }
});
